import { AfterViewInit, Component, ElementRef, HostListener, input, signal, viewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AclDirective } from 'app/shared/acl/acl-resource.directive';
import { Resource } from 'app/shared/acl/acl.model';


export interface Item {
    link: string;
    icon?: string;
    text: string;
    aclResource?: Resource | Resource[] | null;
}


@Component({
    selector: 'ui-nav',
    imports: [
        RouterModule,
        AclDirective,
    ],
    styles: [
        `
        :host {
            position: relative;
        }
        .navbar {
            display: flex;
            flex-wrap: nowrap;
            border-bottom: 1px solid #d8e7f0;
            overflow-x: auto;
            scrollbar-width: thin;
        }
        .nav-item {
            flex-shrink: 0;
            flex-grow: 0;
            color: var(--primary);
            padding: 0.5rem 1.5rem 0.25rem 1.5rem;
        }
        .nav-item.active {
            border-bottom: 3px solid #1583D6;
        }
        .nav-item:hover {
            text-decoration: none;
            color: #0e5890;
            border-bottom: 3px solid #1067a8;
        }

        .more {
            width: 75px;
            pointer-events: none;
            position: absolute;
            top: 0;
            bottom: 0;
        }
        .more.left {
            left: 0;
            background: linear-gradient(90deg, rgba(0,0,0,.3), rgba(0,0,0,0)) no-repeat;
        }
        .more.right {
            right: 0;
            background: linear-gradient(90deg, rgba(0,0,0,0), rgba(0,0,0,.3));
        }

        @media (max-width: 767px) {
            .nav-item {
                padding: 0.5rem 1.5rem;
            }
        }
        `,
    ],
    template: `
        <div class="navbar" role="navigation" #el (scroll)="onScroll()">
            @for (item of items(); track item.link) {
                <a class="nav-item" *apAcl="item.aclResource" [routerLink]="item.link" routerLinkActive="active">
                    @if (item.icon) {
                        <img [src]="item.icon" [alt]="item.text">
                    }
                    @else {
                        {{ item.text }}
                    }
                </a>
            }
        </div>
        @if (moreLeft()) {
            <div class="more left" animate.enter="fade-enter" animate.leave="fade-leave"></div>
        }
        @if (moreRight()) {
            <div class="more right" animate.enter="fade-enter" animate.leave="fade-leave"></div>
        }
    `,
})
export class NavComponent implements AfterViewInit {

    items = input.required<Item[]>();

    el = viewChild.required<ElementRef>('el');

    moreLeft = signal(false);

    moreRight = signal(false);

    ngAfterViewInit() {
        this.onScroll();
    }

    @HostListener('window:resize')
    onResize() {
        this.onScroll();
    }

    onScroll() {
        const el = this.el().nativeElement;
        this.moreLeft.set(el.scrollLeft - el.clientLeft > 16);
        this.moreRight.set(el.scrollWidth - (el.clientWidth + el.scrollLeft) > 16);
    }
}
